import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {WidgetFlag} from '../../../../lib/WidgetFlag'
import {IconLock} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const FooterInfo = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const showFooter = api.resolveConfigWithSingleResult<boolean>('showFooter')

  if (!showFooter) {
    return null
  }

  const showOverlay = () => {
    api.flags.add(WidgetFlag.SHOW_OVERLAY_DATA_PROTECTION_POLICY)
  }

  return (
    <div className="footer-info">
      <div className="header">
        <IconLock />
      </div>
      <div className="main">
        <div
          className="text"
          dangerouslySetInnerHTML={{
            __html: api.trans('blocks.footer_info.text_html'),
          }}
        />
        <button type="button" onClick={showOverlay}>
          <span className="link">{api.trans('blocks.footer_info.link')}</span>
        </button>
      </div>
    </div>
  )
})
